import React from 'react';
import { Typography, TextField, RadioGroup, FormControlLabel, Radio, Checkbox, Select, MenuItem } from '@mui/material';

const Pergunta = ({ pergunta, respostas, setRespostas, handleChange, renderSubPerguntas, modoEdicao, classes }) => {
  const handleCheckboxChange = (event, perguntaId) => {
    const currentRespostas = respostas[perguntaId] || [];
    if (event.target.checked) {
      setRespostas({
        ...respostas,
        [perguntaId]: [...currentRespostas, event.target.value],
      });
    } else {
      setRespostas({
        ...respostas,
        [perguntaId]: currentRespostas.filter((value) => value !== event.target.value),
      });
    }
  };

  return (
    <div className={classes.pergunta}>
      <Typography className={classes.perguntaTexto}>{pergunta.texto}</Typography>

      {/* Placeholder (TextField) */}
      {pergunta.tipo_resposta === 'placeholder' && (
        modoEdicao ? (
          <TextField
            value={respostas[pergunta.id] || ''}
            onChange={(event) => handleChange(event, pergunta.id)}
            variant="outlined"
            fullWidth
            className={classes.respostaInput}
          />
        ) : (
          <Typography className={classes.respostaTexto}>{respostas[pergunta.id] || 'Não respondido'}</Typography>
        )
      )}

      {/* RadioGroup */}
      {pergunta.tipo_resposta === 'radio' && (
        modoEdicao ? (
          <RadioGroup
            value={respostas[pergunta.id] || ''}
            onChange={(event) => handleChange(event, pergunta.id)}
            className={classes.radioGroup}
          >
            {/* Se houver opções personalizadas, mostre-as, senão, exiba SIM/NÃO */}
            {pergunta.opcoes_resposta ? (
              pergunta.opcoes_resposta.map((opcao) => (
                <FormControlLabel key={opcao} value={opcao} control={<Radio />} label={opcao} />
              ))
            ) : (
              <>
                <FormControlLabel value="SIM" control={<Radio />} label="SIM" />
                <FormControlLabel value="NAO" control={<Radio />} label="NÃO" />
              </>
            )}
          </RadioGroup>
        ) : (
          <Typography className={classes.respostaTexto}>
            {respostas[pergunta.id] || 'Não respondido'}
          </Typography>
        )
      )}

      {/* Checkbox */}
      {pergunta.tipo_resposta.toLowerCase() === 'checkbox' && (
        modoEdicao ? (
          Array.isArray(pergunta.opcoes_resposta) && pergunta.opcoes_resposta.length > 0 ? (
            pergunta.opcoes_resposta.map((opcao) => (
              <FormControlLabel
                key={opcao}
                control={
                  <Checkbox
                    checked={respostas[pergunta.id]?.includes(opcao) || false}
                    onChange={(event) => handleCheckboxChange(event, pergunta.id)}
                    value={opcao}
                  />
                }
                label={opcao}
              />
            ))
          ) : (
            <Typography>Nenhuma opção disponível</Typography>
          )
        ) : (
          <Typography className={classes.respostaTexto}>
            {Array.isArray(respostas[pergunta.id])
              ? respostas[pergunta.id].join(', ')
              : respostas[pergunta.id] || 'Não respondido'}
          </Typography>
        )
      )}

      {/* Select */}
      {pergunta.tipo_resposta === 'select' && (
        modoEdicao ? (
          <Select
            value={respostas[pergunta.id] || ''}
            onChange={(event) => handleChange(event, pergunta.id)}
            fullWidth
            variant="outlined"
          >
            {pergunta.opcoes.map((opcao) => (
              <MenuItem key={opcao} value={opcao}>
                {opcao}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Typography className={classes.respostaTexto}>
            {respostas[pergunta.id] || 'Não respondido'}
          </Typography>
        )
      )}

      {/* Renderiza subperguntas se a resposta for "SIM" */}
      {respostas[pergunta.id] === 'SIM' && renderSubPerguntas(pergunta.subperguntas)}
    </div>
  );
};

export default Pergunta;
